import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';

const RoomResponsibleTable = ({ roomsResponsible, onRowClick }) => {
  const { t } = useTranslation();
  const roomsResponsibleDepartmentTextFilterProps =
    useDataGridTextFilter('departmentName');
  const roomsResponsibleFullNameTextFilterProps =
    useDataGridTextFilter('fullName');

  const columns = [
    {
      title: t('Pracovisko'),
      dataIndex: 'departmentName',
      width: '30%',
      ...roomsResponsibleDepartmentTextFilterProps,
    },
    {
      title: t('Zodpovedné osoby'),
      dataIndex: 'responsible_full_names',
      ...roomsResponsibleFullNameTextFilterProps,
    },
  ];

  return (
    <>
      <DataGrid
        rowKey={(row) => row.id}
        columns={columns}
        dataSource={roomsResponsible || []}
        permissionsBasic={'room-responsible'}
        uniqueTableId={'room-responsible-table'}
        onEditClick={onRowClick}
        onRowClick={onRowClick}
        //onDelete={onDelete}
      />
    </>
  );
};

RoomResponsibleTable.propTypes = {
  roomsResponsible: PropTypes.array,
  onDelete: PropTypes.func,
  onCreateClick: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default RoomResponsibleTable;
